import { Link } from 'react-router-dom';
import { FaArrowRight, FaCalendarAlt } from 'react-icons/fa';

export default function YearEntryCard({
  to,
  year,
  title,
  description,
  actionLabel,
  badge,
  icon,
  logoSrc,
  logoAlt,
  meta = [],
  tone = 'teal',
  status = 'pending',
  statusLabel = 'ยังไม่ได้บันทึก'
}) {
  return (
    <Link className={`app-year-card app-year-card--${tone}`} to={to}>
      <div className="app-year-card__surface">
        <div className="app-year-card__hero">
          <div className="app-year-card__brand-shell">
            <div className="app-year-card__brand-mark">
              {logoSrc ? (
                <img src={logoSrc} alt={logoAlt} className="app-year-card__brand-image" />
              ) : (
                <span className="app-year-card__brand-fallback">
                  {icon || <FaCalendarAlt />}
                </span>
              )}
            </div>
            <div className="app-year-card__hero-copy">
              <span className="app-year-card__badge">{badge}</span>
              <strong>พ.ศ. {year}</strong>
            </div>
          </div>
          <div className="app-year-card__hero-side">
            <div className={`app-year-card__status app-year-card__status--${status}`}>
              {statusLabel}
            </div>
            <div className="app-year-card__year-pill">ปี {year}</div>
          </div>
        </div>

        <div className="app-year-card__body">
          <h3>{title}</h3>
          <p>{description}</p>
          {meta.length > 0 && (
            <div className="app-year-card__meta-list">
              {meta.map((item) => (
                <span key={item} className="app-year-card__meta-chip">{item}</span>
              ))}
            </div>
          )}
        </div>

        <div className="app-year-card__footer">
          <span className="app-year-card__cta">
            <span>{actionLabel}</span>
            <FaArrowRight />
          </span>
        </div>
      </div>
    </Link>
  );
}